import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  IconButton,
  Box,
  Drawer,
  Button,
  TextField,
  List,
  ListItem,
  ListItemText,
  Typography,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CircleIcon from "@mui/icons-material/Circle";
import { UseProduct } from "./UseProduct";
import { useSnackbar } from "notistack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import useBreakpoints from "../../hooks/useBreakpoints";
export default function ListMaker(props) {
  const { generateListID, lastOrderRow } = UseProduct();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [tempChar, setTempChar] = useState({ id: 0, orderRow: 0, title: "" });
  const addTitle = useRef(null);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (open) {
      addTitle.current.focus();
    }
  }, [open]);

  return (
    <Grid item md={4} xs={12} sx={{ height: "20rem", mb: 3 }}>
      <Grid
        sx={{
          boxShadow: 2,
          p: 1,
          m: 1,
          borderRadius: "10px",
          height: "100%",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography>لیست {props.name} محصول</Typography>
          <IconButton onClick={() => setOpen(true)}>
            <AddCircleIcon color="secondary" />
          </IconButton>
        </Box>

        <List
          dense={true}
          sx={{
            borderColor: "divider",
          }}
        >
          {props.list &&
            props.list.map((elem, i) => {
              return (
                <ListItem
                  key={i}
                  secondaryAction={
                    <Box>
                      <IconButton
                        sx={{ mr: 0.5 }}
                        onClick={() => editBarcode(elem.orderRow)}
                        edge="end"
                        aria-label="EditIcon"
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => props.deleteRow(elem.orderRow)}
                        edge="end"
                        aria-label="delete"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  }
                >
                  {/* <CircleIcon color="secondary" style={{ width: "10px" }} /> */}
                  <Box sx={{ display: "flex" }}>
                    <Tooltip title="up">
                      <IconButton
                        sx={{ p: 0 }}
                        onClick={() => RowUp(elem.orderRow)}
                      >
                        <ArrowDropUpIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="down">
                      <IconButton
                        sx={{ p: 0 }}
                        onClick={() => RowDown(elem.orderRow)}
                      >
                        <ArrowDropDownIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <ListItemText
                    primaryTypographyProps={{
                      width: "88% !important",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                    sx={{
                      ml: 1,
                    }}
                    primary={elem.title}
                  />
                </ListItem>
              );
            })}
          {props.state &&
            props.state.map((elem, i) => {
              return (
                <ListItem
                  key={i}
                  secondaryAction={
                    <Box>
                      <IconButton
                        sx={{ mr: 0.5 }}
                        onClick={() => editBarcode(elem.orderRow)}
                        edge="end"
                        aria-label="EditIcon"
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => props.deleteRow(elem.orderRow)}
                        edge="end"
                        aria-label="delete"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  }
                >
                  {/* <CircleIcon color="secondary" style={{ width: "10px" }} /> */}
                  <Box sx={{ display: "flex" }}>
                    <Tooltip title="up">
                      <IconButton
                        sx={{ p: 0 }}
                        onClick={() => RowUp(elem.orderRow)}
                      >
                        <ArrowDropUpIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="down">
                      <IconButton
                        sx={{ p: 0 }}
                        onClick={() => RowDown(elem.orderRow)}
                      >
                        <ArrowDropDownIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <ListItemText
                    primaryTypographyProps={{
                      width: "88% !important",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                    sx={{
                      ml: 1,
                    }}
                    primary={elem.title}
                  />
                </ListItem>
              );
            })}
        </List>
      </Grid>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => {
          setOpen(false);
          setTempChar({ orderRow: 0, title: "" });
        }}
        sx={{
          "&  .MuiDrawer-paper": {
            height: "40%",
            width: isSmall ? "90%" : "30%",
            mx: "auto",
            borderRadius: 3,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <TextField
          color="secondary"
          id="outlined-multiline-static"
          label=" متن را وارد نمایید ..."
          multiline
          rows={7}
          autoFocus
          value={tempChar.title}
          inputRef={addTitle}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              submitBarcode();
            }
          }}
          onChange={(event) => {
            setTempChar({
              ...tempChar,
              title: event.target.value,
            });
          }}
          style={{ width: "90%", margin: "auto" }}
        />
        <Box sx={{ mx: "auto", mb: 3 }}>
          <Button
            variant="contained"
            sx={{ width: "100px", mr: 2 }}
            color="secondary"
            onClick={() => submitBarcode()}
          >
            تایید
          </Button>
          <Button
            variant="outlined"
            sx={{ width: "100px" }}
            color="secondary"
            onClick={() => {
              setTempChar({ orderRow: 0, title: "" });
              setOpen(false);
            }}
          >
            انصراف
          </Button>
        </Box>
      </Drawer>
    </Grid>
  );

  function editBarcode(id) {
    setOpen(true);
    setTempChar({
      orderRow: id,
      title: props.state
        ? props.state.find((b) => b.orderRow == id).title
        : props.list.find((b) => b.orderRow == id).title,
    });
  }

  function submitBarcode() {
    if (tempChar.title) {
      var tempList = props.list ? props.list.slice() : props.state.slice();

      if (
        tempList.some(
          (m) => m.title == tempChar.title && m.orderRow !== tempChar.orderRow
        )
      ) {
        enqueueSnackbar(" مورد تکراری است", {
          variant: "error",
          autoHideDuration: 2000,
        });
        return;
      }

      if (tempChar.orderRow == 0) {
        var newtempChar = {
          id: 0,
          title: tempChar.title.trim(),
          orderRow: lastOrderRow(props.list ? props.list : props.state)
            ? lastOrderRow(props.list ? props.list : props.state)
            : 1,
        };
        tempList.push(newtempChar);
        props.list ? props.setter(tempList) : props.setState(tempList);
        setOpen(false);
        setTempChar({ orderRow: 0, title: "" });
      } else {
        tempList.find((b) => b.orderRow == tempChar.orderRow).title =
          tempChar.title.trim();
        props.list ? props.setter(tempList) : props.setState(tempList);
        setOpen(false);
        setTempChar({ orderRow: 0, title: "" });
      }
    }
  }

  function RowDown(id) {
    var Array = props.list ? props.list : props.state;
    if (id == Array.length) {
      return;
    }
    let ind = Array.findIndex((m) => m.orderRow == id);
    let ind2 = Array.findIndex((m) => m.orderRow == id + 1);
    if (ind == Array.length) {
      return;
    }
    let ingList = Array.map((m, i) => {
      if (i == ind2) {
        m.orderRow = id;
      }
      if (i == ind) {
        m.orderRow = id + 1;
      }
      return m;
    });
    props.list ? props.setter(ingList) : props.setState(ingList);
  }

  function RowUp(id) {
    var Array = props.list ? props.list : props.state;
    if (id == 1) {
      return;
    }
    let ind = Array.findIndex((m) => m.orderRow == id);
    let ind2 = Array.findIndex((m) => m.orderRow == id - 1);
    if (ind == Array.length) {
      return;
    }
    let ingList = Array.map((m, i) => {
      if (i == ind2) {
        m.orderRow = id;
      }
      if (i == ind) {
        m.orderRow = id - 1;
      }
      return m;
    });
    props.list ? props.setter(ingList) : props.setState(ingList);
  }
}
